import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import { removeNullKeys } from '@/helpers/http'
import { getPlayables, getPlayable } from '@/api/playable'
import { get, clone } from 'lodash'

import userModule from '@/store/modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  modules: {
    user: userModule
  },
  state: {
    currentProject: null,
    sortBy: 'date_desc',
    searchName: null,
    playablesLoading: false,
    playables: [],
    playablesPagination: null,
    currentPlayableLoading: false,
    currentPlayable: null
  },
  getters: {
    currentProject: state => state.currentProject,
    isPlayablesLoading: state => state.playablesLoading,
    playables: state => state.playables,
    playablesPagination: state => state.playablesPagination || {},
    playablesNextPage: (state, getters) => get(getters.playablesPagination, 'next_page', null),
    currentPlayableId: state => state.route.params.playable_id,
    currentPlayable: state => state.currentPlayable,
    isCurrentPlayableLoading: state => state.currentPlayableLoading,
    sortByMethod: state => state.sortBy,
    searchNameQuery: state => state.searchName
  },
  mutations: {
    SET_CURRENT_PROJECT (state, value) {
      state.currentProject = value
    },
    WATCH_PLAYABLES (state, value) {
      state.playables = value
    },
    APPEND_PLAYABLES (state, value) {
      state.playables.push(...value)
    },
    WATCH_PLAYABLES_LOADING (state, value) {
      state.playablesLoading = value
    },
    WATCH_PLAYABLES_PAGINATION (state, value) {
      state.playablesPagination = value
    },
    WATCH_CURRENT_PLAYABLE (state, value) {
      state.currentPlayable = value
    },
    CLEAR_CURRENT_PLAYABLE (state) {
      state.currentPlayable = null
    },
    WATCH_CURRENT_PLAYABLE_LOADING (state, value) {
      state.currentPlayableLoading = value
    },
    SET_SORT_BY_METHOD (state, value) {
      state.sortBy = value
    },
    SET_SEARCH_NAME (state, value) {
      state.searchName = value
    }
  },
  actions: {
    fetchPlayables ({commit, getters}) {
      commit('WATCH_PLAYABLES', [])
      commit('WATCH_PLAYABLES_LOADING', true)
      return getPlayables(removeNullKeys({
        project_id: getters.currentProject,
        sort_by: getters.sortByMethod,
        search_name: getters.searchNameQuery
      })).then(response => {
        commit('WATCH_PLAYABLES', response.data.result)
        commit('WATCH_PLAYABLES_PAGINATION', response.data.pagination)
        commit('WATCH_PLAYABLES_LOADING', false)
        return Promise.resolve(response)
      }).catch(error => {
        commit('WATCH_PLAYABLES_LOADING', false)
        return Promise.reject(error)
      })
    },
    appendFetchPlayables ({commit, getters}) {
      if (!getters.playablesNextPage) return
      commit('WATCH_PLAYABLES_LOADING', true)
      return getPlayables(removeNullKeys({
        project_id: getters.currentProject,
        sort_by: getters.sortByMethod,
        page: getters.playablesNextPage
      })).then(response => {
        commit('APPEND_PLAYABLES', response.data.result)
        commit('WATCH_PLAYABLES_PAGINATION', response.data.pagination)
        commit('WATCH_PLAYABLES_LOADING', false)
        return Promise.resolve(response)
      }).catch(error => {
        commit('WATCH_PLAYABLES_LOADING', false)
        return Promise.reject(error)
      })
    },
    fetchPlayable ({commit, getters}) {
      commit('WATCH_CURRENT_PLAYABLE_LOADING', true)
      return getPlayable(getters.currentPlayableId, {})
        .then(response => {
          commit('WATCH_CURRENT_PLAYABLE_LOADING', false)
          commit('WATCH_CURRENT_PLAYABLE', response.data)
          return Promise.resolve(response)
        }).catch(error => {
          commit('WATCH_CURRENT_PLAYABLE_LOADING', true)
          return Promise.reject(error)
        })
    }
  }
})
